import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "../../wepcg/sidebar/help_hints";
import "../../wepcg/sidebar/css/wepcg_bar.css"

class DamageInTransitBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Damage in Transit (Box/Product Damage)</strong></h1>
            <p>
                This claim type is used for outside package damage during transport, or the damage of both: package and goods. Please upload photos of the machine and/or damage on the packaging. The damage must be clearly visible on the picture. Photos need to show the details of the box and pallet labels and the serial number on the machine itself, so that photos can be paired without any doubt. Make sure POD is signed with reservation or a damage protocol signed by driver and consignee. We ask you to submit the claim as soon as possible, latest in 5 business days after the delivery (POD date). Please contact our financial claims team in case there is any question or problem.
            </p>
            <Help_hints />
        </div>
    }
}

export default DamageInTransitBar;